import { ControlValueAccessor, FormControl } from '@angular/forms';
import { ContextService } from 'core/services/context.service';
import { DestroyRef, inject } from '@angular/core';

export abstract class AbstractFilterDropdownComponent<T> implements ControlValueAccessor {
  public formControl = new FormControl();
  public value: T | null = null;
  protected contextService = inject(ContextService);
  protected readonly destroyRef = inject(DestroyRef);

  public writeValue(value: T): void {
    this.value = value;
    this.formControl.setValue(value);
  }

  public registerOnChange(onChange: (value: T) => void): void {
    this.onChange = onChange;
  }

  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  public onChange = (value: T): void => {
    //placeholder implementation
    console.log(`Value changed ${value}`);
  };

  public onTouched = (): void => {
    //placeholder implementation
    console.log(`Form control ${AbstractFilterDropdownComponent.name} touched`);
  };

  public updateSelected(value: T): void {
    this.value = value;
    this.onChange(value);
  }

  public setDisabledState(isDisabled: boolean): void {
    if (isDisabled) {
      this.formControl.disable({ emitEvent: false });
    } else {
      this.formControl.enable({ emitEvent: false });
    }
  }
}
